import React from 'react'
import arTitles from '../../../../common/services/mock/title.json'
import { getPathName, changeCurrancyFormat, changeDataFormat} from '../../../../common/utils/utilsFunc'
import { LiferayService } from '../../../../common/services/liferay';
import TableLastTickets from '../TableLastTickets';


const LastTickets = ({ props }) => {
    const [newArrayExcel, setNewArrayExcel] = React.useState([])
    const [newArray, setNewArray] = React.useState()

    React.useEffect(() => {
        if (props.listTickets) {
            let newArrayExcel = JSON.parse(JSON.stringify(props.listTickets))
            newArrayExcel = [...newArrayExcel, newArrayExcel?.map((aux) => {
                if (aux.FechaEmision.split('-')[0].length === 4) {
                    aux.FechaEmision = changeDataFormat(aux.FechaEmision);
                }
                if (aux.TotalPagar[0] !== '$') {
                    aux.TotalPagar = changeCurrancyFormat(aux.TotalPagar);
                }
            })]

            let newArray = JSON.parse(JSON.stringify(props.listTickets))
            newArray = [...newArray, newArray?.map((aux) => {
                if (aux.FechaEmision.split('-')[0].length === 4) {
                    aux.FechaEmision = changeDataFormat(aux.FechaEmision);
                }
                if (aux.TotalPagar[0] !== '$') {
                    aux.TotalPagar = changeCurrancyFormat(aux.TotalPagar);
                }
            })]
            newArrayExcel?.splice(props.qnt_list_boletas, 1)
            newArray?.splice(props.qnt_list_boletas, 1)
            newArrayExcel && setNewArrayExcel(newArrayExcel)
            newArray && setNewArray(newArray)
        }

    }, [props.listTickets])

    let newArrTitle = arTitles[getPathName()]?.map((item) => item.label);

    return (
        <div>
            {newArrayExcel?.length > 0 &&
                <>
                        <TableLastTickets props={{ ...props, newArray, newArrTitle, newArrayExcel }} />

                </>}
        </div>

    )
}

export default LastTickets